import type { IGlobalMarkThemeByName } from '@visactor/vchart';

export const markByName: IGlobalMarkThemeByName = {
  label: {
    style: {
      lineJoin: 'bevel'
    }
  }
};
